module.exports = __webpack_public_path__ + "assets/e2417fa77fbad6d1d77cc4b6135652db.mp3";